/**
 * Key is CMS component name, value is JSON component name.
 */
export default {
  'benefits-table.list-with-ticks': 'ListWithTicks',
  'benefits-table.comparison-table': 'ComparisonTable',
  'body-text.body-text-slider': 'BodyTextSlider',
  'body-text.body-text-with-cta': 'BodyTextWithCTA',
  'body-text.body-texts-container': 'BodyTextsContainer',
  'body-text.body-text-with-double-cta': 'BodyTextWithDoubleCTA',
  'body-text.body-text-with-marketing-properties': 'BodyTextWithMarketingProperties',
  'components.banner-with-search': 'BannerWithSearch',
  'faq.original-faq': 'FAQ',
  'intro-text.intro-text': 'IntroText',
  'icon-block.icon-block-with-cta': 'IconBlockWithCTAs',
  'featured-in.featured-in-with-logos': 'FeaturedInWithLogos',
  'featured-list.image-and-bullet-list': 'ImageAndBulletList',
  'featured-list.image-and-cta': 'ImageAndCTA',
  'image-slider.image-slider-with-cta': 'ImageSliderWithCTA',
  'image-slider.image-slider-with-dynamic-templates': 'ImageSliderWithDynamicTemplates',
  'image-slider.image-slider-with-thumbnail-carousel': 'ImageSliderWithThumbnailCarousel',
  'header-banner.animated-banner-with-bullets': 'AnimatedBannerWithBullets',
  'header-banner.banner-with-image': 'BannerWithImage',
  'header-banner.banner-with-wallpaper': 'BannerWithWallpaper',
  'header-banner.banner-with-dynamic-slider': 'HeaderBannerWithDynamicSlider',
  'header-banner.banner-with-cta-and-bullets': 'HeaderBannerWithCTAAndBullets',
  'how-to.how-to-icons': 'HowToIcons',
  'how-to.how-to-old-version': 'HowToOldVersion',
  'how-to.clickable-how-to': 'ClickableHowTo',
  'image-grid.grid-with-templates': 'GridWithTemplates',
  'summary.summary-with-featured-items': 'Summary',
  'summary.text-in-box-design': 'TextInBoxDesign',
  'testimonial.testimonial-with-card-design': 'TestimonialWithCardDesign',
  'testimonial.testimonial-with-titles': 'TestimonialWithTitles',
  'text-blocks.blocks-on-background': 'BlocksOnBackground',
  'text-blocks.blocks-with-ticks': 'BlocksWithTicks',
  'thumbnails-url.thumbnails-url-with-header-and-description':
    'ThumbnailsUrlWithHeaderAndDescription',
  'thumbnails-url.list-with-pagination-and-cta': 'ListWithPaginationAndCTA',
  'use-case-demo.interactive-images': 'InteractiveImages',
  'use-case-demo.use-case-with-toggle': 'UseCaseWithToggle',
  'components.sticky-bar': 'StickyBar',
  'components.feature': 'FeatureList',
  'redesigned.banner-block': 'BannerBlock',
  'redesigned.explore-similar-pages': 'ExploreSimilarPages',
  'redesigned.banner-carousel': 'BannerCarousel',
  'redesigned.summary': 'RedesignedSummary',
  'redesigned.faq': 'RedesignedFAQ',
  'redesigned.templates': 'Templates',
  'redesigned.all-tools': 'AllTools',
  'home.cover-section': 'CoverSection',
  'home.design-for-section': 'DesignForSection',
  'home.image-slider-with-cta-home': 'ImageSliderWithCtaHome',
  'home.explore-banner': 'ExploreBanner',
  'home.testimonials-carousel': 'TestimonialsCarousel',
  'home.barcode-section': 'BarcodeSection',
  'home.home-top-section': 'HomeTopSection',
  'home.trust-box': 'TrustBox',
  'home.design-for-use-cases': 'DesignForUseCases',
  'home.banner-with-cta': 'BannerWithCTA',
  'home.review-scroller': 'ReviewScroller',
  'home.app-download-section': 'AppDownloadSection',
  'home.pricing-cards-section': 'PricingCardsSection',
  'home.page-linking-component': 'PageLinkingComponent',
  'home.start-for-free': 'StartForFree',
  'colors.color-picker-banner': 'ColorPickerBanner',
  'colors.hub-cards': 'HubCards',
  'colors.links': 'Links',
  'components.fonts': 'Fonts',
  'components.sizes': 'Sizes',
  'components.suggested-templates': 'SuggestedTemplates',
  'colors.color-meanings': 'ColorMeanings',
  'colors.colorDetails': 'ColorDetails',
  'colors.colorWithText': 'ColorWithText',
  'colors.title-with-description': 'TitleWithDescription',
  'colors.color-banner': 'ColorBanner',
  'colors.text-link-with-image': 'ClickableImageWithTextList',
  'colors.color-templates': 'ColorTemplates',
  'components.template-banner-carousel': 'TemplateBannerCarousel',
  'components.templates-categories': 'TemplatesCategories',
};
